import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Check, ChevronDown, ChevronRight, Minus } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuTrigger,
    } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import type { Table } from '@tanstack/vue-table';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { computed, ref } from 'vue';
    import BulkCloseVouchers from '@/components/vouchers/BulkCloseVouchers.vue';
    import BulkApproveVouchers from '@/components/vouchers/BulkApproveVouchers.vue';
    import BulkRemoveVouchers from '@/components/vouchers/BulkRemoveVouchers.vue';
    import BulkIgnoreVouchers from '@/components/vouchers/BulkIgnoreVouchers.vue';
    import BulkMarkAsMissingVouchers from '@/components/vouchers/BulkMarkAsMissingVouchers.vue';
    import BulkAssignAssignedVouchers from '@/components/vouchers/BulkAssignAssignedVouchers.vue';
    import BulkAssignProjectVouchers from '@/components/vouchers/BulkAssignProjectVouchers.vue';
    import BulkCloseVouchersAlertDialog from '@/components/vouchers/BulkCloseVouchersAlertDialog.vue';
    import BulkApproveVouchersAlertDialog from '@/components/vouchers/BulkApproveVouchersAlertDialog.vue';
    import BulkRemoveVouchersAlertDialog from '@/components/vouchers/BulkRemoveVouchersAlertDialog.vue';
    import BulkIgnoreVouchersAlertDialog from '@/components/vouchers/BulkIgnoreVouchersAlertDialog.vue';
    import BulkMarkAsMissingVouchersDialog from '@/components/vouchers/BulkMarkAsMissingVouchersDialog.vue';
    import BulkAssignAssignedVouchersDialog from '@/components/vouchers/BulkAssignAssignedVouchersDialog.vue';
    import BulkAssignProjectVouchersDialog from '@/components/vouchers/BulkAssignProjectVouchersDialog.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherBulkActions',
  props: {
    table: {}
  },
  setup(__props: any) {

    const props = __props;

    const { hasPermission } = usePermissions();

    const selectedVouchers = computed<Voucher[]>(() =>
        props.table.getSelectedRowModel().rows.map((row) => row.original),
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DropdownMenu), null, {
      default: _withCtx(() => [
        _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              variant: "ghost_primary",
              size: "xs",
              width: "narrow",
              class: "ml-auto",
              disabled: !selectedVouchers.value.length
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('vouchers.select.other_options')) + " ", 1),
                _createVNode(_unref(ChevronDown))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }),
        _createVNode(_unref(DropdownMenuContent), { align: "end" }, {
          default: _withCtx(() => [
            _createVNode(BulkCloseVouchers, { "selected-vouchers": selectedVouchers.value }, null, 8, ["selected-vouchers"]),
            _createVNode(BulkApproveVouchers, { "selected-vouchers": selectedVouchers.value }, null, 8, ["selected-vouchers"]),
            (_unref(hasPermission)(_unref(Permission).VOUCHERS_ADMIN_DELETE))
              ? (_openBlock(), _createBlock(BulkRemoveVouchers, {
                  key: 0,
                  "selected-vouchers": selectedVouchers.value
                }, null, 8, ["selected-vouchers"]))
              : _createCommentVNode("", true),
            _createVNode(BulkIgnoreVouchers, { "selected-vouchers": selectedVouchers.value }, null, 8, ["selected-vouchers"]),
            _createVNode(BulkMarkAsMissingVouchers, { "selected-vouchers": selectedVouchers.value }, null, 8, ["selected-vouchers"]),
            _createVNode(BulkAssignAssignedVouchers, { "selected-vouchers": selectedVouchers.value }, null, 8, ["selected-vouchers"]),
            _createVNode(BulkAssignProjectVouchers, { "selected-vouchers": selectedVouchers.value }, null, 8, ["selected-vouchers"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(BulkCloseVouchersAlertDialog, { table: _ctx.table }, null, 8, ["table"]),
    _createVNode(BulkApproveVouchersAlertDialog, { table: _ctx.table }, null, 8, ["table"]),
    _createVNode(BulkRemoveVouchersAlertDialog, { table: _ctx.table }, null, 8, ["table"]),
    _createVNode(BulkIgnoreVouchersAlertDialog, { table: _ctx.table }, null, 8, ["table"]),
    _createVNode(BulkMarkAsMissingVouchersDialog, { table: _ctx.table }, null, 8, ["table"]),
    _createVNode(BulkAssignAssignedVouchersDialog, { table: _ctx.table }, null, 8, ["table"]),
    _createVNode(BulkAssignProjectVouchersDialog, { table: _ctx.table }, null, 8, ["table"])
  ], 64))
}
}

})